import { Permission } from 'api';
import { RouteDefinition } from './types';

export const getReportsRoutes = (basePath: string) => ({
  path: basePath,
  requiresAny: [Permission.ViewReport, Permission.ViewEorReport],
  certificationsDue: {
    to: `${basePath}/certificationsDue`,
    path: `certificationsDue`,
    requiresAll: [Permission.ViewReport],
  } as RouteDefinition,
  monitoringsDue: {
    to: `${basePath}/monitoringsDue`,
    path: `monitoringsDue`,
    requiresAll: [Permission.ViewReport],
  } as RouteDefinition,
  osmWritingMonitoring: {
    to: `${basePath}/osmWritingMonitoring`,
    path: `osmWritingMonitoring`,
    requiresAll: [Permission.ViewReport],
  } as RouteDefinition,
  eorSpeakingMonitoring: {
    to: `${basePath}/eorSpeakingMonitoring`,
    path: `eorSpeakingMonitoring`,
    requiresAll: [Permission.ViewEorReport],
  } as RouteDefinition,
  examiners: {
    to: `${basePath}/examiners`,
    path: `examiners`,
    requiresAll: [Permission.ViewReport],
  } as RouteDefinition,
  trainingAndStandardisation: {
    to: `${basePath}/training-and-standardisation`,
    path: `training-and-standardisation`,
    requiresAll: [Permission.ViewReport],
  } as RouteDefinition,
  disciplinaryActionDue: {
    to: `${basePath}/disciplinary-action-due`,
    path: `disciplinary-action-due`,
    requiresAll: [Permission.ViewReport],
  } as RouteDefinition,
  odpAssessment: {
    to: `${basePath}/odp-assessment`,
    path: `odp-assessment`,
    requiresAll: [Permission.ViewReport, Permission.ViewOdp],
  } as RouteDefinition,
  odpMonitoring: {
    to: `${basePath}/odp-monitoring`,
    path: `odp-monitoring`,
    requiresAll: [Permission.ViewReport, Permission.ViewOdp],
  } as RouteDefinition,
});
